<template>
    <div v-if="adminLists.length > 0">
        <div class="vx-row">
            <div class="vx-col w-full font-bold">Organization Name</div>
            <div class="vx-col w-full md:w-1/3 ml-3 mt-2"><vs-input class="w-full" type="text" v-model="organization_name" /></div>
        </div>
        <div class="vx-row mt-4">
            <div class="vx-col w-full font-bold">Address</div>
        </div>
        <div class="vx-row mt-2 items-center">
            <div class="vx-col w-full ml-3 md:w-1/6">Country</div>
            <div class="vx-col w-full md:w-1/3 ml-3 mt-2"><vs-input class="w-full" type="text" v-model="country" /></div>
        </div>
        <div class="vx-row mt-2 items-center">
            <div class="vx-col w-full ml-3 md:w-1/6">Street 1</div>
            <div class="vx-col w-full md:w-1/3 ml-3 mt-2"><vs-input class="w-full" type="text" v-model="street1" /></div>
        </div>
        <div class="vx-row mt-2 items-center">
            <div class="vx-col w-full ml-3 md:w-1/6">Street 2</div>
            <div class="vx-col w-full md:w-1/3 ml-3 mt-2"><vs-input class="w-full" type="text" v-model="street2" /></div>
        </div>
        <div class="vx-row mt-2 items-center">
            <div class="vx-col w-full ml-3 md:w-1/6">City</div>
            <div class="vx-col flex-grow md:flex ml-3 mt-2 items-center">
                <vs-input class="w-full" type="text" v-model="city" />
                <div class="mt-2 mb-2 md:mt-0 md:mb-0 md:px-4">State/Province/Region</div>
                <vs-input class="w-full" type="text" v-model="region" />
                <div class="mt-2 mb-2 md:mt-0 md:mb-0 md:px-4">Zip</div>
                <vs-input class="w-full" type="text" v-model="zip" />
            </div>
            <!-- <div class="vx-col w-full ml-3 md:w-1/7">State/Province/Region</div>
            <div class="vx-col w-full md:w-1/6 ml-3 mt-2"><vs-input class="w-full" type="text" v-model="region" /></div>
            <div class="vx-col w-full ml-3 md:w-1/7">Zip Code</div>
            <div class="vx-col w-full md:w-1/6 ml-3 mt-2"><vs-input class="w-full" type="text" v-model="zip" /></div> -->
        </div>
        <div class="vx-row mt-2 items-center">
            <div class="vx-col w-full ml-3 md:w-1/6">Phone</div>
            <div class="vx-col w-full md:w-1/3 ml-3 mt-2"><vs-input class="w-full" type="text" v-model="phone" /></div>
        </div>
        <div class="vx-row mt-4">
            <div class="vx-col w-full font-bold">Primary Administrator</div>
            <div class="vx-col w-full md:w-1/3 ml-3 mt-2">
                <vs-select v-model="admin" class="w-full select-large">
                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in adminLists" class="w-full" />
                </vs-select>
            </div>
        </div>
        <div class="vx-row mt-4">
            <div class="vx-col w-full font-bold">Email or Username</div>
            <!-- <div class="vx-col w-full md:w-1/3 ml-3 mt-2">{{adminUser.email}}</div> -->
        </div>

        <div class="flex justify-center">
          <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-save" @click.prevent="submitForm">Save</vs-button>
        </div>
    </div>
</template>

<script>
import api from "@/api";
export default {
    data() {
      return {
        id: '',
        organization_name: '',
        country: '',
        street1: '',
        street2: '',
        phone: '',
        city: '',
        region: '',
        zip: '',
        adminUser: '',
        admin: '',
        adminLists: []
      }
    },
  mounted() {
    this.getAdminLists()

    const generalData = this.$store.getters.getGeneralData
    console.log(generalData)
    if(generalData != null) {
      this.id = generalData.id;
      this.organization_name = generalData.organizationName;
      this.country = generalData.country;
      this.street1 = generalData.address1;
      this.street2 = generalData.address2;
      this.phone = generalData.phone;
      this.city = generalData.city;
      this.region = generalData.province;
      this.zip = generalData.postalCode;
      this.admin = generalData.adminUserId;
      this.adminUser = generalData.adminUser;
    } else {
      this.$router.push({name:'org_management'})
    }
  },
  methods: {
    getAdminLists() {
      api.adminLists()
      .then(result => result.data)
      .then(data => {
        if(data.status) {
            let adm = [{
                text: '-- Select Admin --',
                value: ''
            }]
            data.data.map(d => {
                adm.push({
                    text: d.name,
                    value: d.userId
                })
            })
            this.adminLists = adm
        }
        this.$vs.loading.close()
      })
      .catch((e) => {
        console.log(e)
        this.$vs.loading.close()
      });
    },
    submitForm() {
        this.$vs.loading()
        api.saveGeneral({
          id: this.id,
          organizationName: this.organization_name,
          address1: this.street1,
          address2: this.street2,
          country: this.country,
          city: this.city,
          province: this.region,
          postalCode: this.zip,
          phone: this.phone,
          email: this.email,
          adminUserId: this.admin,
          statusId: 1
        })
        .then((result) => result.data)
        .then((data) => {
            this.$vs.loading.close()
            if(!data.status) {
                this.$vs.notify({
                    title:'Error',
                    text: data.message,
                    color:'danger',
                    position:'top-right'
                })
            } else {
                this.$vs.notify({
                    title:'Success',
                    text:'Success update data',
                    color:'success',
                    position:'top-right'
                })
                setTimeout(() => {
                  window.location.reload();
                },500)
            }
        })
        .finally(() => {
          this.getGeneralData()
        })
        .catch((e) => {
            console.log(e)

            this.$vs.notify({
              title:'Failed',
              text:'Update data failed',
              color:'danger',
              position:'bottom-center'
          })

            this.$vs.loading.close()
        });
    },
    getGeneralData() {
      this.$vs.loading()
      api.general()
      .then(result => result.data)
      .then(data => {
        if(data.status) {
          this.$store.dispatch('updateGneralData', data.data[0] != undefined ? data.data[0] : null)
        }
      })
      .finally(() => {
        this.getProfile()
      })
      .catch((e) => {
        console.log(e)
        this.$vs.loading.close()
      });
    },
  }
}
</script>